// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import React from "react";
import { Link } from "react-router-dom";
import Header from "../header/HeaderComponent";
import Footer from "../footer/FooterComponent";
import Seo from "../Seo/SeoComponent";
import styles from "./aboutPage.module.scss";

function AboutPage() {
    return (
        <div className={styles.page}>
            <Seo
                title="About"
                description="NihongoTech by TeqSeq is a free, all-in-one app for learning Japanese, from your first hiragana to grammar and kanji."
                path="/about"
            />
            <Header />

            <main className={styles.main}>
                <section className={styles.container}>
                    <h1 className={styles.title}>About NihongoTech</h1>
                    <p className={styles.description}>
                        NihongoTech by TeqSeq is a free, all-in-one app for learning Japanese, from your first
                        hiragana to grammar and kanji - built so you can practise without switching between
                        several different apps. It started as a Japanese keyboard for typing hiragana and
                        katakana, and has grown into a full set of lessons, converters, quizzes, and
                        writing practice tools.
                    </p>

                    <div className={styles.card}>
                        <h2 className={styles.cardTitle}>Mission</h2>
                        <p className={styles.cardText}>
                            Make learning Japanese approachable, through an intuitive keyboard, clear
                            lessons, and practice tools that help it stick.
                        </p>
                    </div>

                    <div className={styles.card}>
                        <h2 className={styles.cardTitle}>Existing features</h2>
                        <p className={styles.featureDate}>As of September 20, 2026</p>
                        <ul className={styles.featureList}>
                            <li>On-screen hiragana and katakana keyboards</li>
                            <li>Basic, voiced, combination, and punctuation character groups</li>
                            <li>Romaji input with automatic hiragana or katakana conversion</li>
                            <li>Common kanji suggestions for typed kana</li>
                            <li>A dedicated hiragana-to-kanji converter for beginner vocabulary</li>
                            <li>A romaji-to-kana converter with a hiragana/katakana mode toggle</li>
                            <li>Example Japanese phrases and converter words for quick input</li>
                            <li>Delete, clear, and copy-to-clipboard controls</li>
                            <li>Lessons covering kana and kanji basics</li>
                            <li>A Japanese grammar section with N5-N4 grammar points</li>
                            <li>XP, learning levels, and progress summaries that grow with your study</li>
                            <li>Achievement badges and first-time celebrations for lessons, grammar, kanji, and
                                vocabulary progress</li>
                            <li>Optional Bluesky sharing for first-time lesson and grammar achievements</li>
                            <li>A full jōyō and jinmeiyō kanji reference with readings, stroke order, and
                                pronunciation audio</li>
                            <li>JLPT N5-N1 filtering for the kanji list and the Kanji Memory Quiz</li>
                            <li>A Kanji Memory Quiz with meaning, reading, and stroke-order exercises, and
                                onyomi/kunyomi reading feedback</li>
                            <li>Hiragana and katakana writing practice, with a per-kanji writing counter</li>
                            <li>A Japanese to English translator, from typed text or a photo</li>
                            <li>An optional WaniKani integration for a kanji study progress dashboard</li>
                            <li>An official 2026 JLPT overseas test-location directory with host and registration
                                details</li>
                            <li>User accounts with email/password or Google sign-in, with cloud sync of
                                learning progress across devices</li>
                            <li>A newsletter, a blog, and a site stats page</li>
                            <li>Responsive layouts for desktop and mobile screens</li>
                        </ul>
                        <p className={styles.releaseLinkText}>
                            Check the <Link to="/releases" className={styles.releaseLink}>release notes</Link> to
                            learn when features were released.
                        </p>
                    </div>

                    <div className={styles.card}>
                        <h2 className={styles.cardTitle}>Credits</h2>
                        <p className={styles.cardText}>
                            Built by TeqSeq.
                        </p>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
}

export default AboutPage;
